<!-- 组件说明 -->
<template>
  <div class="owner">
    <div class="owner-line-1">
      <div class="owner-info">
        <span>老业主</span>
        <span class="owner-name data-info">{{ ownerItem.recUsername }}</span>
      </div>
      <div class="owner-info">
        <span>新客户</span>
        <span class="owner-name data-info">{{ ownerItem.presentee }}</span>
      </div>
      <div class="user">
        <span class="user-info">
          <img
            src="~/common/images/recommend/adviserName.png"
            class="user-avator"
          />
          <span style="color:#544317">
            {{ ownerItem.adviserName }}
          </span>
        </span>
      </div>
    </div>
    <div class="owner-line-2">
      <span>老业主房号</span>
      <span class="room-name data-info">{{ ownerItem.recUserRoomName }}</span>
    </div>
    <div class="owner-line-3">
      <span>带访时间</span>
      <span class="show-time data-info">{{ ownerItem.createDate }}</span>
    </div>
    <div class="owner-line-4">
      <div
        class="btn"
        :style="{ backgroundImage: `url(${imgConfirm})` }"
        @click="operate(ownerItem.id, 1)"
      >
        确认带访
      </div>
      <div
        class="btn"
        :style="{ backgroundImage: `url(${imgRefuse})` }"
        @click="operate(ownerItem.id, 2)"
      >
        拒绝推荐
      </div>
    </div>
    <!-- loading -->
    <loading :show="loadingStatus"></loading>
  </div>
</template>

<script>
import loading from "@/components/loading";
import { Toast } from "vant";
export default {
  props: {
    ownerItem: {
      type: Object,
    },
  },
  components: { loading },
  data() {
    return {
      imgConfirm: require("@/common/images/queren_bg.png"),
      imgRefuse: require("@/common/images/jujue_bg.png"),
      loadingStatus: false,
    };
  },
  computed: {},
  methods: {
    // 确认/拒绝带访
    operate(id, status) {
      this.loadingStatus = true;
      this.$api
        .confirm({
          id: id,
          approveStatus: status,
        })
        .then((res) => {
          this.loadingStatus = false;

          Toast.success(res.message);
          this.$emit("initList");
        })
        .catch((res) => {
          this.loadingStatus = false;

          Toast.fail(res);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.owner {
  width: 690px;
  height: 366px;
  background: #ffffff;
  box-shadow: 0px 4px 12px 0px rgba(164, 164, 164, 0.4);
  border-radius: 16px;
  margin-bottom: 30px;
  padding: 30px 24px 24px 30px;

  font-size: 28px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #666666;
  .owner-line-1 {
    display: flex;
    justify-content: space-between;
    .owner-info {
      line-height: 40px;
      .owner-name {
        margin-left: 30px;
      }
    }
    .user {
      width: 160px;
      height: 40px;
      .user-info {
        background: #f9f4e8;
        border-radius: 0px 12px 12px 12px;
        line-height: 40px;
        padding: 4px 16px;
      }
      .user-avator {
        width: 26px;
        height: 24px;
      }
    }
  }
  .owner-line-2 {
    margin-top: 54px;
    .room-name {
      margin-left: 30px;
    }
  }
  .owner-line-3 {
    margin-top: 52px;
    .show-time {
      margin-left: 58px;
    }
  }
  .owner-line-4 {
    margin-top: 40px;
    display: flex;
    justify-content: space-around;
    .btn {
      width: 212px;
      height: 64px;
      text-align: center;
      color: #ffffff;
      line-height: 64px;
      background-size: 212px 64px;
    }
  }
}

.data-info {
  color: #333333;
}
</style>
